import * as React from 'react';
import { PostSchedule } from './index';
import { PostScheduleViewContext } from './PostSchedule.controller';
import { PostScheduleProvider } from '../../../providers/PostScheduleProvider';
import { QueueCountProvider } from '../../../providers/QueueCountProvider';

export const PostScheduleWrapper = (): JSX.Element => {
  return (
    <PostScheduleProvider>
      <QueueCountProvider>
        <PostSchedule context={PostScheduleViewContext.LIST} />
      </QueueCountProvider>
    </PostScheduleProvider>
  );
};
